import {
  Baby,
  KeyRound,
  Lock,
  MapPinned,
  Plus,
  ShieldCheck,
  Users,
  Vault as VaultIcon,
} from "lucide-react";
import { Link } from "react-router-dom";
import { useSession } from "../App.js";
import type { VaultMode } from "../lib/api.js";
import { BackupBanner } from "../lib/BackupBanner.js";

const MODE_ICON: Record<VaultMode, typeof Baby> = { kid: Baby, guardian: Users, circle: Users };

export function Dashboard() {
  const { me } = useSession();
  if (!me) return null;
  return (
    <div>
      <BackupBanner userId={me.user.id} />
      <div className="row" style={{ justifyContent: "space-between", marginBottom: 12 }}>
        <h2 style={{ margin: 0, display: "flex", alignItems: "center", gap: 8 }}>
          <VaultIcon size={20} className="icon" />
          Vaults
        </h2>
        {me.user.role === "owner" && (
          <Link to="/vaults/new">
            <button className="primary" style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <Plus size={16} />
              New vault
            </button>
          </Link>
        )}
      </div>
      {me.vaults.length === 0 && (
        <div className="card empty">
          <ShieldCheck size={28} className="icon muted" style={{ marginBottom: 8 }} />
          <p className="muted">
            {me.user.role === "owner"
              ? "No vaults yet. A vault protects one person: their devices stream into it, and their confidants can unlock it."
              : "You are not enrolled in any vault yet. Open the invitation link you received."}
          </p>
        </div>
      )}
      <div className="grid">
        {me.vaults.map((v) => {
          const ModeIcon = MODE_ICON[v.mode];
          return (
            <div className="card" key={v.id}>
              <div className="row" style={{ gap: 8, marginBottom: 2 }}>
                <ModeIcon size={18} className="icon muted" />
                <h2 style={{ margin: 0 }}>{v.name}</h2>
              </div>
              <p>
                <span className={`badge ${v.sealed ? "ok" : "warn"}`}>
                  {v.sealed ? "Sealed" : "Not yet sealed"}
                </span>{" "}
                <span className="badge">
                  {v.role === "owner" ? "You own this vault" : `Confidant · ${v.confidant?.status}`}
                </span>
              </p>
              <p className="muted">
                Quorum {v.k} of {v.n} · {v.windowMinutes}-minute windows
              </p>
              <div className="row">
                <Link to={`/vaults/${v.id}`}>
                  <button style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <KeyRound size={15} />
                    Manage
                  </button>
                </Link>
                <Link to={`/vaults/${v.id}/timeline`}>
                  <button style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <MapPinned size={15} />
                    Timeline
                  </button>
                </Link>
                {v.mode === "kid" && (
                  <Link to={`/vaults/${v.id}/decrypt`}>
                    <button
                      className="primary"
                      style={{ display: "flex", alignItems: "center", gap: 6 }}
                    >
                      <Lock size={15} />
                      Decrypt
                    </button>
                  </Link>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
